













import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/auth';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';

import UserApi from '@/apis/UserApi';
import UserStatus from '@/models/UserStatusModel';

export default Vue.extend({
  name: 'Login',
  data() {
    return {
    };
  },
  mounted() {
    if (firebase.auth().currentUser) {
      // auto redirect to homepage if already logged in
      this.$router.push(this.$store.state.homepageRoute);
    }

    this.initFirebaseUi();

    // wait 500ms for firebaseui rendering
    setTimeout(() => {
      this.translateLoginText();
    }, 100);
  },
  methods: {
    initFirebaseUi() {
      const store = this.$store;

      const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
      ui.start('#firebaseui-auth-container', {
        callbacks: {
          signInSuccessWithAuthResult(authResult) {
            if (authResult) {
              if (authResult.additionalUserInfo.isNewUser) {
              // init user data

                store.commit('updateUserStatus', new UserStatus());

                UserApi.init();
              }
            }

            // User successfully signed in.
            // Return type determines whether we continue the redirect automatically
            // or whether we leave that to developer to handle.
            return false;
          },
        },
        // signInSuccessUrl: '/success',
        signInFlow: 'popup',
        signInOptions: [
          firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: false,
          },
          {
            provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
            defaultCountry: 'TW',
          },
        ],
      // Other config options...
      });
    },
    /**
     * A hack to replace english login text with traditional chinese text,
     * this is just a dirty fix.
     *
     * for better localization support, @see https://github.com/firebase/firebaseui-web#building-firebaseui
     */
    translateLoginText() {
      const translations = [
        {
          en: 'Sign in with Google',
          tw: '使用 Google 登入',
        },
        {
          en: 'Sign in with email',
          tw: '使用電子郵件地址登入',
        },
        {
          en: 'Sign in with phone',
          tw: '使用電話號碼登入',
        },
      ];

      translations.forEach((translation) => {
        const xpath = `//span[text()='${translation.en}']`;
        const matchingElement = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
        if (matchingElement) {
          matchingElement.textContent = translation.tw;
        } else {
          console.log(`not found ${translation.en}`);
        }
      });
    },
  },
});
